import React from 'react';
import { useUserPermit } from '../../../context/User.context';
import { BLOCK_AUTHOR_ALLOWED_ROLES } from '../../../core/constants/global-constants';
import { Popover } from 'antd';
import { StopOutlined } from '@ant-design/icons';
import { IBook } from '../../../section/Common/types/types';
import { ACTIONS, useActions } from '../../../context/Actions.context';
import { GAEventIdentifier, GAEventName } from '../../../section/Common/constants';

interface IProps {
  id: string;
  book: IBook;
}

const BlockAuthor: React.FC<IProps> = ({ id, book }) => {
  const { setAction } = useActions();
  const { role } = useUserPermit();
  const isAllowed = BLOCK_AUTHOR_ALLOWED_ROLES.includes(role);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (!isAllowed) {
      return;
    }
    window.gtag('event', GAEventName.actionBlock, {
      identifier: GAEventIdentifier.blockAuthor,
      value: book.Author
    });
    setAction({ book, id, type: ACTIONS.blockAuthor });
  };

  return (
    <Popover
      placement='topLeft'
      content={
        <div className='popover-content'>
          {isAllowed ? `When blocked, all future titles from the author will 
           automatically be moved to the Excluded list. Excluding 
           an author does not affect the Brenda model or 
           training data.`
            : 'You do not have permission to perform this action'}
        </div>
      }
      trigger='hover'
    >
      <StopOutlined
        onClick={handleClick}
        className={`actions-icons actions-icons-block ${!isAllowed ? ' disabled' : ''}`}
        style={
          isAllowed ? {} : {
            cursor: 'not-allowed',
            opacity: 0.8
          }
        }
      />
    </Popover>
  );
};

export default React.memo(BlockAuthor);